const binding = { modules: {}, dataActions: {} };

    const registerActionId = (actionPath) => {
        if (binding.dataActions[actionPath] &&
            binding.dataActions[actionPath].default &&
            binding.dataActions[actionPath].default.prototype &&
            binding.dataActions[actionPath].default.prototype.id) {
            binding.dataActions[binding.dataActions[actionPath].default.prototype.id] = binding.dataActions[actionPath];
        } else {
            Object.keys(binding.dataActions[actionPath] || {}).forEach(exportName => {
                if (binding.dataActions[actionPath][exportName] &&
                    binding.dataActions[actionPath][exportName].prototype &&
                    binding.dataActions[actionPath][exportName].prototype.Action) {
                    binding.dataActions[binding.dataActions[actionPath][exportName].prototype.id] = binding.dataActions[actionPath][exportName];
                }
            })
        }
    };

    const registerSanitizedActionPath = (sanitizedActionPath, dataAction) => {
        if (process.env.NODE_ENV === 'development') {
            if (!dataAction.default) {
                throw new Error('Data action path does not have a default export');
            }
            if (!(dataAction.default.prototype.id && binding.dataActions[dataAction.default.prototype.id]) || !binding.dataActions[sanitizedActionPath]) {
                binding.dataActions[sanitizedActionPath] = dataAction;
            }
        } else {
            binding.dataActions[sanitizedActionPath] = dataAction;
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
    };
    

        {   
            const actionPath = 'actions/access-error-state.action';
            binding.dataActions[actionPath] = require('partner/actions/access-error-state.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/add-gratuity.action';
            binding.dataActions[actionPath] = require('partner/actions/add-gratuity.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/add-order-allergens.action';
            binding.dataActions[actionPath] = require('partner/actions/add-order-allergens.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/assign-cart-customer.action';
            binding.dataActions[actionPath] = require('partner/actions/assign-cart-customer.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/channel-state.action';
            binding.dataActions[actionPath] = require('partner/actions/channel-state.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-all-customer-ecom-carts.action';
            binding.dataActions[actionPath] = require('partner/actions/get-all-customer-ecom-carts.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-all-products.action';
            binding.dataActions[actionPath] = require('partner/actions/get-all-products.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-allergens.action';
            binding.dataActions[actionPath] = require('partner/actions/get-allergens.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-cart-gratuity.action';
            binding.dataActions[actionPath] = require('partner/actions/get-cart-gratuity.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-category-menu.action';
            binding.dataActions[actionPath] = require('partner/actions/get-category-menu.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-customer-account.action';
            binding.dataActions[actionPath] = require('partner/actions/get-customer-account.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-customer-cart.action';
            binding.dataActions[actionPath] = require('partner/actions/get-customer-cart.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-ecom-cart.action';
            binding.dataActions[actionPath] = require('partner/actions/get-ecom-cart.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-ecom2retail-stores.action';
            binding.dataActions[actionPath] = require('partner/actions/get-ecom2retail-stores.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-events.action';
            binding.dataActions[actionPath] = require('partner/actions/get-events.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-item-nutrition-details.action';
            binding.dataActions[actionPath] = require('partner/actions/get-item-nutrition-details.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-order-state.action';
            binding.dataActions[actionPath] = require('partner/actions/get-order-state.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-order-status.action';
            binding.dataActions[actionPath] = require('partner/actions/get-order-status.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-product-modifiers.action';
            binding.dataActions[actionPath] = require('partner/actions/get-product-modifiers.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-retail-store-address.action';
            binding.dataActions[actionPath] = require('partner/actions/get-retail-store-address.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-suite-to-validate-admin.action';
            binding.dataActions[actionPath] = require('partner/actions/get-suite-to-validate-admin.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-user-info.action';
            binding.dataActions[actionPath] = require('partner/actions/get-user-info.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/removeCartLine.action';
            binding.dataActions[actionPath] = require('partner/actions/removeCartLine.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/resume-cart.action';
            binding.dataActions[actionPath] = require('partner/actions/resume-cart.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/set-order-note.action';
            binding.dataActions[actionPath] = require('partner/actions/set-order-note.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/update-cart-line-items.action';
            binding.dataActions[actionPath] = require('partner/actions/update-cart-line-items.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/validate-event.action';
            binding.dataActions[actionPath] = require('partner/actions/validate-event.action');
            registerActionId(actionPath);
        }

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.packageDataActions = {};
        window.__bindings__.packageDataActions['__local__'] = {
            ...binding.dataActions
        };